
const Alphanine = ({ themeColor }) => {
  return (
    <>
      <div className="mx-auto">

        <div className="mt-10 font-bold">
          PATIENT ELIGIBILITY GUIDELINES FOR COPAY ASSISTANCE
        </div>

        <ul className="list-disc ml-10">
          <li className="my-2">Prescription must be for primary immunodeficiency diagnosis</li>
          <li className="my-2">Patients must be at least 2 years of age</li>
          <li className="my-2">Patient must be receiving Hizentra through a specialty pharmacy or physician office</li>
          <li className="my-2">Patient must express financial need</li>
          <li className="my-2">Patient must have coverage for the product under a private US insurance plan. Not valid
            for prescriptions eligible for reimbursement by any federal or state healthcare program, such as Medicare,
            Medicare advantage plans, Medicaid, PCIP, Champus, TriCare, Veterans Administration (VA), or any other state
            or federal program
          </li>
          <li className="my-2">
            Patients whose insurance policy prohibits copay assistance are not eligible*

            <p className="mt-4 italic">
              * Prior to enrolling in this Grifols program, participants are responsible for checking with their
              insurance carrier to confirm that their participation is not inconsistent with their insurance carrier’s
              requirements.
            </p>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Alphanine;
